import { en as sharedEn } from '@piaas/piaas-ui-toolkit/i18n';

import appEn from './app/en';

export default { ...sharedEn, ...appEn };
